import React from "react";
import PropTypes from "prop-types";

import messages from '../../assets/i18n'
import { useSelector } from "react-redux";

function SelectHour (props) {

	const lang = useSelector(state => state.language.name)

	const setHour = hour => {
			const { setHourFuncCallback } = props;
			if (setHourFuncCallback !== undefined) {
					props.setHourFuncCallback(hour);
			}
	};

	const { hours } = props;

	if (hours === undefined) {
		return <h3>{messages[lang].noHourHasBeenPassed}</h3>;
	} else if (hours.length <= 0) {
		return <p className="messages">{messages[lang].noHoursAvailable}</p>;
	} else {
		return (
			<div className="selectHour">
				{hours.map((hour, i) => {
					const active = props.selectedHourFromParent === hour ? "active" : "";
					return (
						<button
							key={i}
							id={`select_hour_hour_button_${hour.replace(":", "")}`}
							type="buttom"
							className={`btn ${active}`}
							onClick={() => setHour(hour)}
						>
							<span>{hour}</span>
						</button>
					);
				})}
			</div>
		);
	}
}

export default SelectHour;

SelectHour.propTypes = {
    hours: PropTypes.array.isRequired,
    selectedHourFromParent: PropTypes.string.isRequired,
    setHourFuncCallback: PropTypes.func.isRequired
};
